import SectionHeader from "@/components/base/SectionHeader";

const reasons = [
  {
    icon: "ri-shield-check-line",
    title: "Federal Enterprise Experience",
    description: "Sustained subcontract performance supporting federal enterprise IT environments with reliable delivery and clear role attribution.",
  },
  {
    icon: "ri-team-line",
    title: "Specialized Technical Teams",
    description: "Qualified engineers, administrators, developers, and SMEs ready for mission-critical government and enterprise programs.",
  },
  {
    icon: "ri-server-line",
    title: "Infrastructure & Database Depth",
    description: "Proven capabilities in enterprise infrastructure, network engineering, virtualization, and database administration.",
  },
  {
    icon: "ri-star-line",
    title: "Prime Contractor Partnerships",
    description: "Reliable subcontracting partner with established relationships and experience delivering within federal teaming structures.",
  },
];

export default function WhyPartnerSection() {
  return (
    <section className="section-padding bg-white">
      <div className="container-page">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <SectionHeader
              title="Why Partner With Mitaja"
              subtitle="A Technology Partner for Government Prime Contractors"
              description="Mitaja partners with prime contractors and technology organizations seeking specialized technical capabilities, qualified resources, and flexible subcontracting support."
              centered={false}
            />
            <div className="space-y-6">
              {reasons.map((reason) => (
                <div key={reason.title} className="flex gap-4">
                  <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className={`${reason.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-foreground-900 mb-1">
                      {reason.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-lg overflow-hidden bg-primary-800">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20team%20collaboration%20in%20modern%20enterprise%20office%20with%20technology%20screens%20and%20network%20diagrams%2C%20clean%20minimal%20interior%2C%20subtle%20blue%20accent%20lighting%2C%20no%20people%20visible%2C%20cinematic%20professional%20photography&width=800&height=600&seq=partner-1&orientation=landscape"
                alt="Enterprise partnership"
                className="w-full h-80 md:h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 to-transparent"></div>
            </div>
            <div className="absolute -bottom-4 -right-4 md:-right-6 bg-white rounded-lg p-4 md:p-5 border border-background-200/80 max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 rounded-full bg-accent-50 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs font-semibold text-foreground-500 uppercase tracking-wider">Subcontract Partner</span>
              </div>
              <p className="text-sm font-semibold text-foreground-800">
                Ready to team on federal, state, and commercial technology programs
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}